import { useDispatch } from "react-redux";
import {
  fetchPublicTemplatesAction,
  fetchPrivateTemplatesAction,
} from "store/actions/templates";
import { toast } from "react-toastify";
import { useCurrentUser, useLogout } from "utils/hooks";

const useFetchTemplates = () => {
  const dispatch = useDispatch();
  const { logOut } = useLogout();
  const { user } = useCurrentUser();

  //TODO: Differentiate keys for public vs private template for permissions
  // and within privat there is a different between draft and published

  const fetchPublicTemplates = () => {
    return new Promise(() => {
      fetch(`${process.env.REACT_APP_API_URL}`, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          query: `
            query {
              getAllPublicTemplates {
                authorId
                authorEmail
                uuid
                title
                description
                instructions
                content
                status
                type
                icon
                color
                slug
                assignedCount
                category
                assessmentScoring {
                  isScoringEnabled
                  scoringInstructions
                  scoringType
                  scoreSuffix
                  scoreAsPercentage
                  isFieldsetScoringEnabled
                  fieldSets {
                    id
                    name
                    fieldScoringType
                    order
                  }
                  scoreDisplays {
                    id
                    name
                    min
                    max
                    color
                    order
                  }
                }
                tags {
                  uuid
                  title
                  color
                  type
                }
                default
                sources
                shareWithOrganization
              }
            }
          `,
        }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          organizationId: user?.activeOrganizationId || "NA",
          permissionKey: "read_published_templates",
        },
      })
        .then(async (res) => {
          if (res.status !== 200 && res.status !== 201) {
            const error = await res.json();
            if (error.errors[0].message.includes("BRKN_6001")) {
              toast.warn(`For security purposes please log in again.`);
              logOut();
            } else {
              toast.error(`Hmm, something went wrong.`);
              throw new Error("Failed!");
            }
          }
          return res.json();
        })
        .then((resData) => {
          if (resData.errors) {
            toast.error(
              `Hmm, something went wrong (Code: 03IMN). ${resData.errors[0].message}`
            );
          } else {
            return dispatch(
              fetchPublicTemplatesAction(resData.data.getAllPublicTemplates)
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  };

  const fetchPrivateTemplates = () => {
    return new Promise(() => {
      fetch(`${process.env.REACT_APP_API_URL}`, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          query: `
          query {
            getAllPrivateTemplates {
              authorId
              uuid
              title
              description
              instructions
              content
              status
              type
              slug
              icon
              color
              assignedCount
              category
              assessmentScoring {
                isScoringEnabled
                scoringInstructions
                scoringType
                scoreSuffix
                scoreAsPercentage
                isFieldsetScoringEnabled
                fieldSets {
                  id
                  name
                  fieldScoringType
                  order
                }
                scoreDisplays {
                  id
                  name
                  min
                  max
                  color
                  order
                }
              }
              tags {
                uuid
                title
                color
                type
              }
              default
              sources
              shareWithOrganization
            }
          }
        `,
        }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          organizationId: user?.activeOrganizationId || "NA",
          permissionKey: "read_draft_templates",
        },
      })
        .then(async (res) => {
          if (res.status !== 200 && res.status !== 201) {
            const error = await res.json();
            if (error.errors[0].message.includes("BRKN_6001")) {
              toast.warn(`For security purposes please log in again.`);
              logOut();
            } else {
              toast.error(`Hmm, something went wrong.`);
              throw new Error("Failed!");
            }
          }
          return res.json();
        })
        .then((resData) => {
          if (resData.errors) {
            toast.error(
              `Hmm, something went wrong. ${resData.errors[0].message}`
            );
          } else {
            return dispatch(
              fetchPrivateTemplatesAction(resData.data.getAllPrivateTemplates)
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  };

  return {
    fetchPublicTemplates,
    fetchPrivateTemplates,
  };
};

export default useFetchTemplates;
